import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { HttpService } from "src/app/shared/services/HttpClientServices/Http.service";

export const CoverResolver: ResolveFn<any> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        return inject(HttpService).get(`SA_CompanyImages?Filter=ImageType eq 1 and IsCurrent eq true`)
        
    };

// NoReserveQtyOnConfirmSalesOrder